<template>
  <div class="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <div class="title">常见问题</div>
    <div class="DetailBox">
      <div class="DetailTitle">{{detail.title}}</div>
      <div class="DetailInfo">
        <div>
          <span>{{detail.create_time}}</span>
          <span class="type">常见问题</span>
        </div>
        <div class="seeNum">
          <img src="../assets/see.png" alt />
          <span>{{detail.number}}</span>
        </div>
      </div>
      <div class="DetailText" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "MyQuestionDetail",
  data() {
    return {
      detail: ""
    };
  },
  components: {},
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
     this.$store.commit("UserSelf", JSON.parse(localStorage.getItem("ZQUserSelf")));
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.detail = this.$route.query.detail;
    this.addNumber();
  },
  methods: {
    addNumber() {
      this.$http
        .get("/api/Problem/update_number", {
          params: {
            id: this.detail.id
          }
        })
        .then(res => {});
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang='scss' scoped>
.box {
  width: 7.5rem;
  height: 100vh;
  background: white;
}
div {
  width: 100%;
  word-wrap: break-word;
}
.title {
  font-size: 0.32rem;
  line-height: 0.9rem;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
}
.back {
  position: absolute;
  top: 0.3rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.DetailBox {
  padding: 0.3rem;
}
.DetailTitle {
  font-size: 0.32rem;
  color: #333333;
  margin-bottom: 0.3rem;
}
.DetailText {
  font-size: 0.24rem;
  line-height: 0.32rem;
  color: #636363;
  margin-top: 0.5rem;
}
.DetailInfo {
  display: flex;
  justify-content: space-between;
  font-size: 0.22rem;
  color: #cbcaca;
}
.type {
  display: inline-block;
  border-radius: 0.2rem;
  border: 1px solid #cbcaca;
  margin-left: 0.2rem;
  padding: 0 0.15rem;
  line-height: 0.32rem;
}
.seeNum {
  display: flex;
  align-items: center;
}
.DetailInfo img {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: 0.2rem;
}
</style>
